import { render, staticRenderFns } from "./ValidataProperty.vue?vue&type=template&id=2de39264&scoped=true&"
import script from "./ValidataProperty.vue?vue&type=script&lang=js&"
export * from "./ValidataProperty.vue?vue&type=script&lang=js&"
import style0 from "./ValidataProperty.vue?vue&type=style&index=0&id=2de39264&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de39264",
  null
  
)

export default component.exports